import { render, staticRenderFns } from "./FormWidget.vue?vue&type=template&id=4bf9863a&"
import script from "./FormWidget.vue?vue&type=script&lang=ts&"
export * from "./FormWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports